import { render, staticRenderFns } from "./InventoryAll.vue?vue&type=template&id=3573f86a&scoped=true&"
import script from "./InventoryAll.vue?vue&type=script&lang=js&"
export * from "./InventoryAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573f86a",
  null
  
)

export default component.exports